// @flow
import { Button, TextBlock, YearMonthRangePopover } from 'bench-internal-theme';
import { getISODateString, getLastDateOfMonth, toDate } from 'date-functions';
import React from 'react';
import styled from 'styled-components';

import type { DateRange } from './types';

const SelectDateRangeNullStateWrapper = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const SelectDateRangeNullStateLayout = styled.div`
  display: grid;
  grid-row-gap: 8px;
  grid-template-columns: 252px;
  grid-template-rows: min-content;
  text-align: center;
`;

type SelectDateRangeNullStateProps = {
  description: string,
  onRangeSelect: DateRange => any,
  title: string,
};

const SelectDateRangeNullState = ({
  description,
  onRangeSelect,
  title,
}: SelectDateRangeNullStateProps) => (
  <SelectDateRangeNullStateWrapper>
    <SelectDateRangeNullStateLayout>
      <TextBlock aria-label={`${title} Page`} styleType="title">
        {title}
      </TextBlock>
      <TextBlock>{description}</TextBlock>
      <YearMonthRangePopover
        defaultDisplayedYear={new Date().getFullYear()}
        onRangeSelect={(startYearMonth: string | null, endYearMonth: string | null) => {
          if (!startYearMonth || !endYearMonth) return;
          onRangeSelect({
            endDate: getISODateString(getLastDateOfMonth(endYearMonth)),
            startDate: getISODateString(toDate(startYearMonth)),
          });
        }}
      >
        {showPopover => (
          <Button onFocus={() => showPopover(true)} styleType="primary">
            Select Date Range
          </Button>
        )}
      </YearMonthRangePopover>
    </SelectDateRangeNullStateLayout>
  </SelectDateRangeNullStateWrapper>
);

export default SelectDateRangeNullState;
